.ux-iws-stateful-filter-tags {
    display: block;

    &__container {
        margin-top: 10px;
    }

    .ux-tag {
        padding: 0 0 0 15px;
        margin-right: 15px;
    }

    &__tag-icon {
        height: 100%;
        padding-right: 15px;
        margin-left: 10px;
        cursor: pointer;
    }
}
